<template>
    <div class="table-responsive">
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th v-if="estimateItems.length > 0"></b-th>
                    <b-th>Name:</b-th>
                    <b-th>Type:</b-th>
                    <b-th>Quantity:</b-th>
                    <b-th>Total:</b-th>
                    <b-th>Print On Estimate:</b-th>
                    <b-th>Added:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="estimateItems.length <= 0">
                <b-tr>
                    <td colspan="7">
                        <i>No records available</i>
                    </td>
                </b-tr>
            </b-tbody>
            <draggable
                v-else
                v-model="estimateItems"
                tag="tbody"
                ghost-class="sort-row-ghost"
                drag-class="sort-row-drag"
                :animation="0"
                handle=".handle"
                @start="isRowDragging = true"
                @end="isRowDragging = false"
                @sort="itemsSorted"
            >
                <tr v-for="item in estimateItems" :key="item.id">
                    <td class="handle">
                        <i class="cursor-move cus-black-white-swatch" />
                    </td>
                    <td>
                        <span v-if="isItemBundleType(item)">
                            <router-link
                                :to="{
                                    name: 'template_details',
                                    params: {
                                        type: templateType,
                                        id: item.template.encoded_id
                                    }
                                }"
                                target="_blank"
                                >{{ item.template.name }}</router-link
                            >
                        </span>
                        <span v-else-if="item.item">
                            <router-link
                                v-if="item.item.isactive"
                                :to="{
                                    name: 'item',
                                    params: { id: item.item.encoded_id }
                                }"
                                target="_blank"
                                >{{ item.item.name }}
                                <span v-if="item.item.status == 0"
                                    >(inactive)</span
                                ></router-link
                            >
                            <span v-else>{{ item.item.name }} (deleted)</span>
                        </span>
                        <span v-else>--</span>
                    </td>
                    <td>
                        {{
                            isItemBundleType(item)
                                ? "Bundle"
                                : getItemType(item)
                        }}
                    </td>
                    <td>
                        <span v-if="isItemBundleType(item)">
                            --
                        </span>
                        <span v-else-if="item.item">
                            {{ item.quantity }}
                            <span
                                v-if="
                                    item.max_quantity &&
                                    item.quantity != item.max_quantity
                                "
                            >
                                - {{ item.max_quantity }}</span
                            >
                            {{ item.item.measurement_unit.value }}
                        </span>
                        <span v-else>--</span>
                    </td>
                    <td>
                        {{ getItemTotal(item) }}
                    </td>
                    <td>
                        <span v-if="isItemBundleType(item)"> -- </span
                        ><span v-else>{{
                            item.print_on_invoice ? "Yes" : "No"
                        }}</span>
                    </td>
                    <td>{{ _carbonDateDisplay(item.create_at) }}</td>
                    <td class="text-right small text-nowrap">
                        <span
                            v-if="!isItemBundleType(item)"
                            class="cursor-pointer text-nowrap"
                            @click="editItem(item)"
                        >
                            Edit
                        </span>
                        <span v-if="!isItemBundleType(item)">
                            |
                        </span>
                        <span @click="deleteItem(item)" class="cursor-pointer">
                            Delete
                        </span>
                    </td>
                </tr>
            </draggable>
        </b-table-simple>

        <modal-delete-item ref="modalDeleteItem" @reload="onSuccess" />
    </div>
</template>

<script>
/**
 * @name TemplateEstimateItemList
 * @description List of template Estimate Item
 */

import TemplateService from "@/services/templates";
import ItemMixin from "@/mixins/item";

export default {
    mixins: [ItemMixin],
    components: {
        Loader: () => import("@/components/elements/loader-list"),
        ModalDeleteItem: () =>
            import(
                "@/components/setting-template/bundle-estimate/modal-delete-item"
            ),
        Draggable: () => import("vuedraggable")
    },
    props: {
        estimate: {
            type: Object,
            required: false
        }
    },
    computed: {
        templateId() {
            return this.$store.state.settingsTemplate.templateId;
        },
        templateType() {
            return this.$route.params.type;
        }
    },
    watch: {},
    data() {
        return {
            isLoading: false,
            showPagination: false,
            estimateItems: [],
            isRowDragging: false,
            item: null
        };
    },
    mounted() {
        this.getItems();
    },
    destroyed() {},
    methods: {
        async getItems() {
            try {
                this.isLoading = true;

                const res = await this.$http.get(
                    `${process.env.BARRAMUNDI}account/template/bundle/get-elements/${this.templateId}`
                );

                if (
                    res.data &&
                    res.data.response &&
                    res.data.response.resources
                ) {
                    this.estimateItems = res.data.response.resources;
                }
            } catch (error) {
                console.log(error);
                this._message(error.message, "danger");
            } finally {
                this.isLoading = false;
            }
        },
        editItem(item) {
            this.$store.dispatch("settingsTemplate/openModalItem", {
                isEdit: true,
                item: item
            });
        },
        deleteItem(item) {
            this.$refs.modalDeleteItem.open(this.templateId, item);
        },
        isItemBundleType(item) {
            return item.type == 1;
        },
        onSuccess() {
            this.$emit("reload-details");
        },
        async itemsSorted() {
            const params = {
                id: this.templateId,
                data: this.estimateItems.map(invItem => invItem.id)
            };
            await TemplateService.updateInvoiceEstimateTemplateItemsOrder(
                params
            )
                .then(res => {
                    if (res.code != 200) {
                        throw "Error: Cannot reorder estimate bundle items";
                    }

                    // reset order index
                    this.estimateItems = this.estimateItems.map(
                        (item, index) => ({
                            ...item,
                            index: index
                        })
                    );
                })
                .catch(error => {
                    this._message(error, "danger");
                });
        },
        getItemType(item) {
            return item.item.item_type ? item.item.item_type.value : "";
        }
    }
};
</script>
